import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import List from "../Components/Others/List";
import Add from "../Components/Others/Add";
import Layout from "../Layout";
import View from "../Components/Others/View";

function Others() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} onChange={handleChange} />;

      default:
        return (
          <Add
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            currentOrder={currentOrder}
          />
        );
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Others</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default Others;
